import { ImportMigrationEntryStatusEnum } from 'src/orchd-client';

export const migrationAnalysisHasCompleted = (status: ImportMigrationEntryStatusEnum | undefined): boolean => {
  if (!status) return false;
  return [ImportMigrationEntryStatusEnum.processed, ImportMigrationEntryStatusEnum.failed].includes(status);
};
